import React from "react";
import { Box, Grid } from "@mui/material";
import Img1 from "../assets/images/img-1.min.jpg";
import Img28 from "../assets/images/img-31.min.jpeg";
import Img20 from "../assets/images/img-32.min.jpg";
import CardAction from "./CardAction";

const cards = [
  {
    img: Img28,
    title: "Transformando el Futuro con Biopolímeros",
    subtitle: "Educación y Acción Comunitaria",
    description:
      "Únete a nuestro proyecto para concientizar sobre el impacto de los plásticos y promover alternativas sostenibles. ♻️🌍",
    nameButton: "Participa ahora",
    url: "/Register",
  },
  {
    img: Img20,
    title: "Combatiendo la Contaminación por Plásticos",
    subtitle: "Un esfuerzo que inicia en la comunidad",
    description:
      "Trabajamos junto a comunidades para reducir el uso de plásticos, promover el reciclaje y fomentar soluciones basadas en biopolímeros. 🌱🚀",
    nameButton: "Descubre cómo ayudar",
    url: "/EvidenceResults",
  },
];

const CardActionSection = () => {
  return (
    <Box
      id="content-section-3"
      sx={{
        backgroundImage: `url(${Img1})`,
        backgroundAttachment: { xs: "scroll", md: "fixed" },
        backgroundPosition: "center",
        backgroundSize: "cover",
        width: "100%",
        pt: { xs: 5, md: 9 },
        pb: { xs: 5, md: 6.5 },
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 1240, mx: "auto", px: { xs: 2, sm: 3 } }}>
        <Grid container spacing={{ xs: 2.5, md: 5 }} sx={{ justifyContent: 'center', alignItems: "stretch" }}>
          {cards.map((card, index) => (
            <Grid item xs={12} md={6} key={index}>
              <CardAction
                img={card.img}
                title={card.title}
                subtitle={card.subtitle}
                description={card.description}
                nameButton={card.nameButton}
                url={card.url}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default CardActionSection;
